module.exports = {
	OVERLAY: 'overlay',
	INLINE: 'inline',
	FRAMEWORKS: {
		BOOTSTRAP3: "bootstrap3"
	}
};


//////////////////
// WEBPACK FOOTER
// ./constants/views.js
// module id = 76
// module chunks = 0 5 20